<template>
  <div class="content flex-box">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-hotel"
      entity-name="酒店"
      add-btn="新增酒店"
      hide-show-detail
      :hide-action="!editable"
      :modal-width="640"
      :before-edit="beforeEdit"
      :before-update="beforeUpdate"
      :modal-form="modalForm"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules">
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入酒店名称查询"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="酒店名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入酒店名称"></a-input>
        </a-form-model-item>
        <a-form-model-item label="位置信息" prop="position">
          <coordinate-picker v-model="form.position" @change="val => $set(form, 'location', val ? val.address : null)"></coordinate-picker>
        </a-form-model-item>
        <a-form-model-item label="详细地址" prop="name">
          <a-input v-model="form.location" placeholder="请输入酒店详细地址"></a-input>
        </a-form-model-item>
      </template>
    </data-list>
  </div>
</template>

<script>

    import {getHotelRoomType} from "../../../common/activity/stay";
    import mixins from "../mixins";

    export default {
        name: "ActivityHotel",
        data() {
            return {
                columns: [
                    {title: '酒店名称', dataIndex: 'name'},
                    {title: '酒店地址', dataIndex: 'location'},
                    {title: '房型', dataIndex: 'roomType', customRender: (text, record) => getHotelRoomType(record)},
                    {title: '房间数量', dataIndex: 'room', customRender: text => (text || []).reduce((acc, val) => acc + val.count * 1, 0)},
                ],
                rules: {
                    name: [{ required: true, message: '请输入酒店名称', trigger: 'blur' }],
                    position: [{ required: true, message: '请选择酒店所在的位置', trigger: 'change' }],
                    location: [{ required: true, message: '请输入请输入酒店地址', trigger: 'blur' }],
                },
                visible: false,
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 4},
                    wrapperCol: {span: 20}
                },
                moduleKey: 'stay-room',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&expand=room';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            beforeEdit(form, fn) {
                form.position = {
                    lat: form.lat,
                    lng: form.lng,
                    address: form.location,
                }
                fn();
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                if(form.position) {
                    form.lat = form.position.lat;
                    form.lng = form.position.lng;
                }
                fn();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
